/**
 * Keyword Validation Manager
 * 
 * Handles client-side validation for keyword input fields.
 */

const MIN_KEYWORD_LENGTH = 2

/**
 * Validates keyword input and updates UI accordingly
 * @param {HTMLInputElement} inputElement - The keyword input field
 * @param {HTMLButtonElement[]} submitButtons - Array of submit buttons to enable/disable
 * @param {HTMLElement} minCharMessage - The minimum character warning message element
 * @returns {boolean} - Whether the input is valid
 */
export function validateKeywordInput(inputElement, submitButtons, minCharMessage) {
  if (!inputElement) return false

  const isValid = inputElement.value.length >= MIN_KEYWORD_LENGTH

  submitButtons.forEach(button => {
    if (button) button.disabled = !isValid
  })

  if (minCharMessage) {
    if (isValid) {
      minCharMessage.classList.add('d-none')
      minCharMessage.classList.remove('d-block')
    } else {
      minCharMessage.classList.remove('d-none')
      minCharMessage.classList.add('d-block')
    }
  }

  return isValid
}

/**
 * Sets up initial validation state (buttons disabled, warning shown)
 * @param {HTMLButtonElement[]} submitButtons - Array of submit buttons to disable
 * @param {HTMLElement} minCharMessage - The minimum character warning message element
 */
export function initializeValidationState(submitButtons, minCharMessage) {
  submitButtons.forEach(button => {
    if (button) button.disabled = true
  })

  if (minCharMessage) {
    minCharMessage.classList.remove('d-none')
    minCharMessage.classList.add('d-block')
  }
}

/**
 * Clears the keyword input field
 * @param {HTMLInputElement} inputElement - The keyword input field to clear
 */
export function clearKeywordInput(inputElement) {
  if (inputElement) {
    inputElement.value = ''
  }
}
